import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Phone, Mail, MapPin, Clock, MessageCircle } from "lucide-react";
import Logo from "./Logo";
import { contact } from "../mock";

const Footer = () => {
  return (
    <footer className="relative bg-[#0a121a] border-t border-white/10 pt-16 pb-8 overflow-hidden">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[var(--gold)]/50 to-transparent" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Logo />
            <p className="mt-5 text-sm text-muted-foreground leading-relaxed max-w-xs">
              Executive black-truck transportation, airport transfers, and SafeRide services in Miami — driven by professionals, designed for comfort and peace of mind.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href={contact.instagram}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-[var(--gold)]/40 text-[var(--gold)] hover:bg-[var(--gold)] hover:text-[#0c1620] transition-all"
              >
                <Instagram size={18} />
              </a>
              <a
                href={contact.whatsapp}
                target="_blank"
                rel="noreferrer"
                aria-label="WhatsApp"
                className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-[var(--gold)]/40 text-[var(--gold)] hover:bg-[var(--gold)] hover:text-[#0c1620] transition-all"
              >
                <MessageCircle size={18} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-widest text-[var(--gold)] mb-5">Explore</h4>
            <ul className="space-y-3 text-sm">
              {[
                { l: "Home", to: "/" },
                { l: "Services", to: "/services" },
                { l: "SafeRide", to: "/saferide" },
                { l: "Luxury Add-Ons", to: "/luxury-add-ons" },
                { l: "Book Online", to: "/book" },
              ].map((i) => (
                <li key={i.to}>
                  <Link to={i.to} className="text-gray-300 hover:text-[var(--gold)] transition-colors">{i.l}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-widest text-[var(--gold)] mb-5">Company</h4>
            <ul className="space-y-3 text-sm">
              {[
                { l: "Terms and Conditions", to: "/terms" },
                { l: "Cancellation Policy", to: "/cancellation" },
                { l: "Privacy Policy", to: "/privacy" },
                { l: "FAQs", to: "/faqs" },
              ].map((i) => (
                <li key={i.to}>
                  <Link to={i.to} className="text-gray-300 hover:text-[var(--gold)] transition-colors">{i.l}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-widest text-[var(--gold)] mb-5">Get in Touch</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-center gap-3 text-gray-300">
                <Phone size={16} className="text-[var(--gold)]" />
                <a href={`tel:${contact.phoneRaw}`} className="hover:text-[var(--gold)]">{contact.phone}</a>
              </li>
              <li className="flex items-center gap-3 text-gray-300">
                <Mail size={16} className="text-[var(--gold)]" />
                <a href={`mailto:${contact.email}`} className="hover:text-[var(--gold)]">{contact.email}</a>
              </li>
              <li className="flex items-center gap-3 text-gray-300">
                <MapPin size={16} className="text-[var(--gold)]" /> {contact.city}
              </li>
              <li className="flex items-center gap-3 text-gray-300">
                <Clock size={16} className="text-[var(--gold)]" /> 24/7 Service
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} Shadow Path Services. All rights reserved.
          </p>
          <p className="text-xs text-muted-foreground">Licensed • Insured • Escalade Fleet • Miami, FL</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
